import styles from "./Head.module.css";

type HeadPropsType = {
  title: string;
  description: string;
  step?: number;
};

const Head = ({ title, description, step = 1 }: HeadPropsType) => {
  return (
    <div className={styles.headContainer}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
      <p className={styles.description}>Paso {step} / 3</p>
    </div>
  );
};

export default Head;
